import SignatureCanvas from 'react-signature-canvas';

export type CaptureSignatureProps = {
    signCanvasRef: any,
    imageData?: string,
    onBegin?: Function,
    onEnd?: Function,
    onClear?: Function,
    populate?: boolean
}
const CaptureSignature = ({ signCanvasRef, imageData, onBegin, onEnd, populate }: CaptureSignatureProps) => {

    return (
        <div className='of-hidden mn-height-160 flex-center'>
            {
                populate && imageData ?
                    <img src={imageData} alt="" />
                    :
                    <SignatureCanvas
                        ref={signCanvasRef}
                        penColor='black'
                        onBegin={(event) => { onBegin && onBegin(event) }}
                        onEnd={(event) => { onEnd && onEnd(event) }}
                        canvasProps={{ width: 1920, height: 150, className: 'sigCanvas' }} />
            }
        </div>
    )
}

export default CaptureSignature
